import { atom } from 'jotai';

interface State {
  isOpen: boolean;
  urls: string[];
  index: number;
}

export const imageDialogAtom = atom<State>({ isOpen: false, urls: [], index: 0 });
